export default {
	"AddressItem.edit": "編輯"
}